import React from 'react';
import { motion } from 'framer-motion';

const VaultenWordmark = ({ visible }) => {
  if (!visible) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 3, delay: 1 }}
      className="fixed top-8 left-1/2 -translate-x-1/2 z-20"
    >
      <div className="flex flex-col items-center gap-1">
        {/* Wordmark */}
        <span 
          className="font-display text-sm tracking-[0.35em] uppercase"
          style={{ color: 'hsl(40, 20%, 70%)' }}
        >
          Vaulten
        </span>
        
        {/* Subtle line beneath */}
        <motion.div 
          className="w-8 h-px"
          style={{ backgroundColor: 'hsl(40, 15%, 30%)' }}
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 2, delay: 2 }}
        />
      </div>
    </motion.div>
  );
};

export default VaultenWordmark;
